import { z } from 'zod';

/**
 * Wire view of a destination photo exposed through {@link TripViewSchema}: trip-api
 * enrichment. `source` is where the photo comes from, for the credit line — the
 * files may be served from our own CDN. Wikimedia photos are CC BY/BY-SA (or free):
 * the credit must name the author, the license and link the source page. `voll` is our
 * own catalog: its license asks for no credit, so no screen shows one.
 */
export const DestinationImageSourceSchema = z.enum(['unsplash', 'wikimedia', 'voll']);
export type DestinationImageSource = z.infer<typeof DestinationImageSourceSchema>;

export const DestinationImageUrlsSchema = z.object({
  thumb: z.string(),
  small: z.string(),
  regular: z.string(),
  full: z.string(),
});

export const DestinationImageViewSchema = z.object({
  url: z.string(), // urls.regular — convenience default
  urls: DestinationImageUrlsSchema,
  photographer: z.string(),
  photographerUrl: z.string(),
  source: DestinationImageSourceSchema,
  license: z.string().optional(),
  licenseUrl: z.string().optional(),
  sourceUrl: z.string().optional(),
});
export type DestinationImageView = z.infer<typeof DestinationImageViewSchema>;
